import React from "react";
import { Link } from "react-router-dom";

import "../styles/Seo.css";
import SeoMetaTags, { SITE_ORIGIN } from "./SeoMetaTags";

export const HOME_PATH = "/";
export const HOME_TITLE =
  "Poker Hand Equity Calculator - Free Range vs Range Odds";
export const HOME_DESCRIPTION =
  "Free poker hand equity calculator. Build Texas Hold'em ranges on the 13x13 grid, add a board, and see every player's equity instantly. No signup, no ads.";

function appJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: "Poker Hand Equity Calculator",
    alternateName: ["Poker Range Calculator", "Hold'em Equity Calculator"],
    url: SITE_ORIGIN,
    applicationCategory: "GameApplication",
    operatingSystem: "Any",
    browserRequirements: "Requires JavaScript",
    description: HOME_DESCRIPTION,
    offers: { "@type": "Offer", price: "0", priceCurrency: "USD" },
    featureList: [
      "Hand ranges for up to nine players on a 13x13 grid",
      "Individual suit combination selection",
      "Flop, turn and river board input",
      "Shareable calculation links"
    ]
  };
}

export function HomeMetaTags() {
  return (
    <SeoMetaTags
      title={HOME_TITLE}
      description={HOME_DESCRIPTION}
      path={HOME_PATH}
      jsonLd={[appJsonLd()]}
    />
  );
}

// Lives on the guide, not the calculator: the tool pages stay clean. Headings
// start at h2 so the guide keeps a single h1.
export function HoldemGuideSections(props) {
  return (
    <section className="seoArticle">
      <h2>Poker Hand Equity Calculator</h2>
      <p>
        Compare Texas Hold'em ranges hand versus hand. Pick a player, click the
        hands they hold on the grid, add a board if you have one, and the{" "}
        <Link to="/">poker hand equity calculator</Link> shows each player's
        share of the pot.
      </p>

      <h3>What you can work out</h3>
      <ul>
        <li>
          Range versus range equity for up to nine players, not just hand versus
          hand.
        </li>
        <li>
          Individual suit combinations — take only the suited combos of a hand,
          or drop the ones your board blocks.
        </li>
        <li>
          Equity before the flop, or after any flop, turn or river you enter.
        </li>
      </ul>

      <p>
        Playing four-card games? The{" "}
        <Link to="/omaha">pot limit Omaha equity calculator</Link> handles PLO,
        where each player is dealt four hole cards and must use exactly two of
        them.
      </p>
    </section>
  );
}
